import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClipboardJS from "clipboard";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import typescript from "react-syntax-highlighter/dist/esm/languages/hljs/typescript";
import { a11yLight } from "react-syntax-highlighter/dist/esm/styles/hljs";
import VisibilitySensor from "react-visibility-sensor";
import Spacer from "../../components/Utils/Spacer";
import TitleHome from "../../components/Utils/TitleHome";
import { Context } from "../../context";
import classes from "./About.module.css";

const AboutHome = () => {
  const codeRef = useRef(null);
  SyntaxHighlighter.registerLanguage("typescript", typescript);
  const { debug, lang } = useContext(Context);

  if (debug) {
    console.log("render About");
  }

  const [isVisible, setIsVisible] = useState(false);
  const [age, setAge] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const calculateAge = (dateOfBirth) => {
    const now = Date.now();
    const ageInMillis = now - dateOfBirth;
    const ageInSeconds = ageInMillis / 1000;
    const ageInYears = ageInSeconds / (365.25 * 24 * 60 * 60);
    return Math.floor(ageInYears);
  };

  function convertToHexadecimal(number) {
    return number.toString(16).toUpperCase();
  }

  useEffect(() => {
    const decimalNumber = calculateAge(293820400000);
    const hexadecimalValue = convertToHexadecimal(decimalNumber);
    setAge(hexadecimalValue);
  }, []);

  const code = `
      const developer: PersonalData = {
        name: "Davide",
        surname: "Balice",
        email: "davide.balice@gmail.com",
        dateOfBirthTimestamp: 294504263,
        ageHex: ${age},
        location: {
          name: "Reggio Calabria",
          coordinates: {
            latitude: 38.11058724041668,
            longitude: 15.645301603328178,
          },
        },
        skills: [
          "Php",
          "Laravel",
          "Node",
          "Spring",
          "React",
          "Angular",
          "JavaScript",
          "TypeScript",
          "Three.js",
        ],
      };
    `;

  useEffect(() => {
    new ClipboardJS(codeRef.current);
  }, []);

  return (
    <section id="about" className={classes.bgCode + " section p_zero"}>
      <Container>
        <div className="position-relative d-flex text-left mb-2">
          <div className="container-fluid">
            <TitleHome text="AboutMe = () " color="white" />
          </div>
        </div>
      </Container>
      <Spacer height="20" />
      <div className="container">
        <div className="row gy-5">
          <VisibilitySensor
            onChange={changeVisibility}
            partialVisibility
            delayedCall
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 20,
              }}
              transition={{ duration: 0.4, delay: 1 }}
              className="col-lg-7 col-xl-8 text-justify text-lg-start"
              style={{ paddingRight: "40px" }}
            >
              {lang === "en" && (
                <>
                  <h2 className="text-7 fw-600 mb-3">
                    I'm <span className="text-primary">Davide Balice,</span> a
                    full stack web developer
                  </h2>
                  <div className={classes.sectionDivider}></div>
                  <p className="text-4">
                    I've been in the industry for + than 15 years, I started
                    with the php, mysql and javascript stack, but have been
                    exploring new technologies and frameworks for the past few
                    years.
                    <br />
                    <br />I worked on several projects in different fields, from
                    the creation of websites to the creation of complex
                    applications. My passion for programming constantly pushes
                    me to learn new technologies. I like working in a team and
                    sharing my knowledge by collaborating to achieve common
                    goals.
                  </p>
                </>
              )}
              {lang === "it" && (
                <>
                  <h2 className="text-7 fw-600 mb-3">
                    Sono <span className="text-primary">Davide Balice,</span> un
                    full stack web developer
                  </h2>
                  <p className="text-4">
                    Sono nel settore da più di 15 anni, ho iniziato con lo stack
                    php, mysql e javascript, ma negli ultimi anni sono passato
                    ai moderni framework richiesti dal mercato.
                    <br />
                    <br />
                    Ho lavorato a diversi progetti in diversi campi, dal
                    creazione di siti web alla creazione di complesse
                    applicazioni. La mia passione per la programmazione mi
                    spinge costantemente ad imparare nuove tecnologie. Mi piace
                    lavorare in squadra e condividere le mie conoscenze
                    collaborando per raggiungere obiettivi comuni.
                  </p>
                </>
              )}

              <div className="brands-grid mt-5">
                <div className="row">
                  <div className="col-6 col-md-3">
                    <VisibilitySensor
                      onChange={changeVisibility}
                      partialVisibility
                      delayedCall
                    >
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 1.7 }}
                        className="featured-box text-center"
                      >
                        <h4 className="text-12 text-muted mb-0">
                          <span className="counter" data-from="0" data-to="10">
                            15
                          </span>
                          +
                        </h4>
                        <p className="mb-0">
                          {lang === "en" && <>Years Experiance</>}
                          {lang === "it" && <>Anni di esperienza</>}
                        </p>
                      </motion.div>
                    </VisibilitySensor>
                  </div>
                  <div className="col-6 col-md-3">
                    <VisibilitySensor
                      onChange={changeVisibility}
                      partialVisibility
                      delayedCall
                    >
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 2 }}
                        className="featured-box text-center"
                      >
                        <h4 className="text-12 text-muted mb-0">
                          <span className="counter" data-from="0" data-to="250">
                            100
                          </span>
                          +
                        </h4>

                        {lang === "en" && (
                          <>
                            {" "}
                            <p className="mb-0">Clients</p>
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            {" "}
                            <p className="mb-0">Clienti</p>
                          </>
                        )}
                      </motion.div>
                    </VisibilitySensor>
                  </div>

                  <div className="col-6 col-md-3">
                    <VisibilitySensor
                      onChange={changeVisibility}
                      partialVisibility
                      delayedCall
                    >
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 2.3 }}
                        className="featured-box text-center"
                      >
                        <h4 className="text-12 text-muted mb-0">
                          <span className="counter" data-from="0" data-to="650">
                            100
                          </span>
                          +
                        </h4>
                        <p className="mb-0">
                          {lang === "en" && <>Projects done</>}
                          {lang === "it" && <>Progetti realizzati</>}
                        </p>
                      </motion.div>
                    </VisibilitySensor>
                  </div>
                </div>
              </div>
            </motion.div>
          </VisibilitySensor>

          <VisibilitySensor
            onChange={changeVisibility}
            partialVisibility
            delayedCall
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 20,
              }}
              transition={{ duration: 0.4, delay: 1.2 }}
              className="col-lg-5 col-xl-4"
              style={{ position: "relative" }}
            >
              <div className={classes.codeTop}>
                <span className={classes.copyText}>aboutMe.tsx</span>
                <button
                  className={classes.copyButton}
                  ref={codeRef}
                  data-clipboard-text={code}
                >
                  <FontAwesomeIcon icon={faCopy} />

                  {lang === "en" ? " Copy code" : " Copia codice"}
                </button>
              </div>
              <SyntaxHighlighter
                language="typescript"
                style={a11yLight}
                showLineNumbers
                className={classes.SyntaxHighlighter}
              >
                {code.trim()}
              </SyntaxHighlighter>
            </motion.div>
          </VisibilitySensor>
        </div>
        <div
          className={classes.textCode1}
          style={{ color: "white" }}
        >{`}`}</div>
      </div>

      <Spacer height="100"></Spacer>
    </section>
  );
};

export default AboutHome;
